import { BuildVersion, IEnvironment } from './environment.interface';
import buildVersion from '@env/buildVersion';
import { SamplesModule } from "@app/samples/samples.module";
import { SamplesComponent } from '@app/samples/samples.component';

const apiUrl = 'https://mnc-dev-api-hh.azurewebsites.net';

export const environment: IEnvironment = {
  apiUrl,
  modules: [
    SamplesModule
  ],
  production: false,
  routes: [
    {
      path: ':tenantId/hh',
      component: SamplesComponent,
      children: [
        // Add Sample pages here. Use the code below as a guide.
        // { path: 'hh-component', component: SamplePageComponent, data: { title: 'HH Component' } },
      ]
    },
  ],
  version: buildVersion as BuildVersion,
};
